import { createAction } from '@reduxjs/toolkit';
import { CreateTicketFormData } from 'src/components/pages/CreateNewTicket/CreateNewTicket';
import { ResolveTicketFormData } from 'src/components/pages/ResolveTicket/ResolveTicket';
import {
  ApiPaginationResponse,
  TableQueryParameters,
} from 'src/components/ui/Table/Table.interface';

import { ServiceAccount } from '../models/ServiceAccount';
import { DateRange } from '../models/Stats';
import {
  ListTicket,
  MapFilter,
  Ticket,
  TicketNote,
  TicketStatistics,
  TicketStatus,
} from '../models/Ticket';

export const TICKET_SLICE = 'ticket';

/* Map filter */
export const setMapFilter = createAction<MapFilter>(
  `${TICKET_SLICE}/setMapFilter`
);

/* Ticket list */
export const getTicketList = createAction<{
  manId?: string;
  params: TableQueryParameters<TicketStatus, ListTicket>;
}>(`${TICKET_SLICE}/getTicketList`);

export const setTicketList = createAction<
  ApiPaginationResponse<ListTicket[], TicketStatus>
>(`${TICKET_SLICE}/setTicketList`);

/* Priority tickets */
export const getPriorityTickets = createAction(
  `${TICKET_SLICE}/getPriorityTickets`
);

export const setPriorityTickets = createAction<ListTicket[]>(
  `${TICKET_SLICE}/setPriorityTickets`
);

/* Ticket details */
export const getTicketDetails = createAction<{ id: string }>(
  `${TICKET_SLICE}/getTicketDetails`
);

export const setTicketDetails = createAction<Ticket>(
  `${TICKET_SLICE}/setTicketDetails`
);

/* Create ticket */
export const createTicket = createAction<CreateTicketFormData>(
  `${TICKET_SLICE}/createTicket`
);

/* Access ticket with PIN */
export const accessTicketPIN = createAction<{
  unitId: string;
  ticketId: number;
  pin: string;
}>(`${TICKET_SLICE}/accessTicketPIN`);

/* Ticket notes */
export const getTicketNotes = createAction<{ ticketId: number }>(
  `${TICKET_SLICE}/getTicketNotes`
);

export const setTicketNotes = createAction<TicketNote[]>(
  `${TICKET_SLICE}/setTicketNotes`
);

/* Add ticket note */
export const addTicketNote = createAction<{ ticketId: number; text: string }>(
  `${TICKET_SLICE}/addTicketNote`
);

/* Resolve ticket */
export const resolveTicket = createAction<{
  ticketId: number;
  resolveData: ResolveTicketFormData;
}>(`${TICKET_SLICE}/resolveTicket`);

/* Assign ticket */
export const assignTicket = createAction<{
  ticketId: number;
  service: ServiceAccount;
}>(`${TICKET_SLICE}/assignTicket`);

/* Ticket statistics */
export const getTicketStatistics = createAction<{
  range: DateRange;
  status: TicketStatus;
}>(`${TICKET_SLICE}/getTicketStatistics`);

export const setTicketStatistics = createAction<{
  status: TicketStatus;
  stats: TicketStatistics;
}>(`${TICKET_SLICE}/setTicketStatistics`);

/* Reassign ticket */
export const reassignTicket = createAction<{
  ticketId: number;
  service: ServiceAccount;
}>(`${TICKET_SLICE}/reassignTicket`);
